module.exports = __webpack_public_path__ + "img/02.31242433.jpg";